namespace GeniuzPOS.Inventory {
    export interface IcStockSetAssembleDtForm {
        LineItemNo: Serenity.IntegerEditor;
        PluCode: Serenity.StringEditor;
        PluDesc: Serenity.StringEditor;
        SetItemQty: Serenity.DecimalEditor;
        SetQty: Serenity.DecimalEditor;
        Qty: Serenity.DecimalEditor;
        SkuCode: Serenity.StringEditor;
        SkuQty: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
    }

    export class IcStockSetAssembleDtForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockSetAssembleDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockSetAssembleDtForm.init)  {
                IcStockSetAssembleDtForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(IcStockSetAssembleDtForm, [
                    'LineItemNo', w0,
                    'PluCode', w1,
                    'PluDesc', w1,
                    'SetItemQty', w2,
                    'SetQty', w2,
                    'Qty', w2,
                    'SkuCode', w1,
                    'SkuQty', w2,
                    'Remark', w1
                ]);
            }
        }
    }
}
